import * as Sentry from '@sentry/nuxt'

const { sentryDsn, release, environment } = useRuntimeConfig().public
Sentry.init({
  // If set up, you can use your runtime config here
  // dsn: useRuntimeConfig().public.sentry.dsn,
  dsn: sentryDsn,
  release: 'sepac@' + release,
  environment,
  ignoreErrors: [/statusCode=404|statusMessage=Seite nicht gefunden/mi],
  integrations: [
    Sentry.thirdPartyErrorFilterIntegration({
      filterKeys: ['sepac'], // application key specified in sentry vite plugin
      behaviour: 'drop-error-if-exclusively-contains-third-party-frames',
    }),
  ],
  denyUrls: [
    'googletagmanager.com',
    'google-analytics.com',
    'outbrain.com',
    'facebook.net',
    'taboola.com',
    'pinterest.com',
    'pinimg.com',
  ],
  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 0.0,
})
